import { isFeatureEnabled } from 'owa-feature-flags';

export default function isProjectionFlightEnabled() {
    return isFeatureEnabled('cal-forms-popout-projection');
}
